
<div class="services-minis" :class="getOccupation">
  {{ room.name }} ({{ oPercent }} %)
  <span v-if="ms && cashState(ms)"> - {{ getTypeCash(cashState(ms).type) }} : {{ cashState(ms).value }}€ / c</span>
  <span v-if="cashState(ms).nbCouv">({{ cashState(ms).nbCouv }})</span>
</div>
